import type {
  AnalyticsTableColumn,
  AnalyticsTableSorting,
} from '../../../analyticsModule/components/AnalyticsTable/AnalyticsTable.types'
import { useAnalyticsParams } from '../../../modules/AnalyticsParams/hooks/useAnalyticsParams'
import type { AnalyticsReportData } from '../../../types'
import { createAnalyticsTableData } from './utils/createAnalyticsTableData'

type UseAnalyticsReportTableParams = {
  reportData: AnalyticsReportData | undefined
  columns: AnalyticsTableColumn[]
  isLoading: boolean
  sorting: AnalyticsTableSorting | undefined
  onSortingChange: (columnId: string) => void
  activeSeries?: string
}

export const useAnalyticsReportTable = ({
  reportData,
  columns,
  sorting,
  onSortingChange,
  isLoading,
  activeSeries,
}: UseAnalyticsReportTableParams) => {
  const params = useAnalyticsParams()

  const getIsFirstRowSummary = () => {
    if (!reportData) {
      return false
    }

    return 'summary' in reportData.report && !!reportData.report.summary
  }

  return {
    isLoading,
    columns,
    data: createAnalyticsTableData(reportData, columns, sorting),
    activeColumnId: activeSeries,
    sorting,
    onSortingChange,
    emptyMessage: 'No data found in this date range',
    isFirstRowSummary: getIsFirstRowSummary(),
    precision: params.precision.value.value,
  }
}
